import { render, staticRenderFns } from "./SecurityCard.vue?vue&type=template&id=3cd49aed&scoped=true"
import script from "./SecurityCard.vue?vue&type=script&lang=js"
export * from "./SecurityCard.vue?vue&type=script&lang=js"
import style0 from "./SecurityCard.vue?vue&type=style&index=0&id=3cd49aed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd49aed",
  null
  
)

export default component.exports